jQuery( document ).ready(function($) {
    $('.header-mobile-open').click(function() {
        $('.header-mobile-wrapper').addClass('header-mobile-wrapper-active');
    });

    $('.header-mobile-close').click(function() {
        $('.header-mobile-wrapper').removeClass('header-mobile-wrapper-active');
    });

    $('.single-project-gallery').slick({
        arrows: true,
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('.single-project-gallery-prev'),
        nextArrow: $('.single-project-gallery-next'),
    });
});



document.addEventListener("DOMContentLoaded", function() {
    // Получаем кнопки для переключения валюты
    var usdButton = document.querySelector('.cur-usd');
    var eurButton = document.querySelector('.cur-eur');
    var gelButton = document.querySelector('.cur-gel');

    // Обработчик клика по кнопке USD
    usdButton.addEventListener('click', function() {
        localStorage.setItem('currency', 'USD'); // Сохраняем выбранную валюту в localStorage
        updateTable(); // Обновляем таблицу с новой валютой
        console.log(234123)
    });

    // Обработчик клика по кнопке EUR
    eurButton.addEventListener('click', function() {
        localStorage.setItem('currency', 'EUR'); // Сохраняем выбранную валюту в localStorage
        updateTable(); // Обновляем таблицу с новой валютой
    });

    // Обработчик клика по кнопке GEL
    gelButton.addEventListener('click', function() {
        localStorage.setItem('currency', 'GEL'); // Сохраняем выбранную валюту в localStorage
        updateTable(); // Обновляем таблицу с новой валютой
    });

    // Функция обновления таблицы с учетом выбранной валюты
    function updateTable() {
        var currency = localStorage.getItem('currency') || 'GEL'; // Получаем выбранную валюту из localStorage
        var amountCells = document.querySelectorAll('.amount'); // Получаем ячейки с суммами

        // Обновляем суммы в таблице с учетом выбранной валюты
        amountCells.forEach(function(cell) {
            var amount = parseFloat(cell.dataset.amount); // Получаем сумму из атрибута data-amount
            var formattedAmount = formatCurrency(amount, currency); // Форматируем сумму в выбранной валюте
            cell.textContent = formattedAmount; // Обновляем текст ячейки с новой суммой
        });
    }

    // Функция форматирования суммы в выбранной валюте
    function formatCurrency(amount, currency) {
        var multipliers = {
            'USD': 0.38, // Множители для конвертации валют
            'EUR': 0.35,
            'GEL': 1
        };
        var multiplier = multipliers[currency] || 1; // Получаем множитель для выбранной валюты
        var result = amount * multiplier;
        var formattedResult = result.toLocaleString('en-US', { style: 'currency', currency: currency }); // Форматируем сумму в валюту с помощью Intl API
        return formattedResult;
    }

    // При загрузке страницы обновляем таблицу с учетом выбранной валюты
    updateTable();
});